import Vue from 'vue';
import Vuex from 'vuex';
import global from '../global/index';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);
export default new Vuex.Store({
  actions,
  mutations,
  getters,
  modules: {
    global,
  },
});
